module.exports = __webpack_public_path__ + "img/logo.d18d4293.png";